import React, { useContext, useRef } from "react";
import "./Study.scss";
import { useParams } from "react-router-dom";

import { Link } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

import { getMostMissedColor } from "../../constants/constants.js";
import LineChart from "../../components/LineChart/LineChart";
import DoughnutChart from "../../components/DoughnutChart/DoughnutChart";
import TestProgress from "../../components/TestProgress/TestProgress";
import TooltipIcon from "../../components/TooltipIcon/TooltipIcon";

import CrunchTimePopup from "../../components/StudyPlanPopups/CrunchTimePopup/CrunchTimePopup";

import FlipCard from "../../components/FlipCard/FlipCard";
import Tags from "../../components/Tags/Tags";
import {
  parse,
  format,
  eachMinuteOfInterval,
  differenceInMinutes,
} from "date-fns";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import ReactGA from "react-ga4";

import {
  get_set_data,
  get_user,
  on_set_closed,
  get_session_token,
  update_set,
  get_tag_color_index,
  get_recall_results,
  get_friends_most_difficult_terms,
  get_tutorial_progress,
} from "../../network/communication";
import { Helmet } from "react-helmet-async";
import MDEditor from "@uiw/react-md-editor";
import { useSpeechSynthesis } from "react-speech-kit";
import Popup from "../../components/Popup/Popup";
import AnalyticsBadge from "../../components/AnalyticsBadge/AnalyticsBadge";
import AddTask from "../../components/AddTask/AddTask";
import WhiteButton from "../../components/WhiteButton/WhiteButton";
import Xarrow, { Xwrapper } from "react-xarrows";
import { MultipleLineChart } from "../../components/MultipleLineChart/MultipleLineChart";
import { addStyles, StaticMathField } from "react-mathquill";
import ProgressBar from "@ramonak/react-progress-bar";
import AnalyticsBanner from "../../components/AnalyticsBanner/AnalyticsBanner";
import PlaceholderRectangle from "../../components/PlaceholderRectangle/PlaceholderRectangle";
import QuizzyPlusBanner from "../../components/QuizzyPlusBanner/QuizzyPlusBanner";
import Sparkles from "react-sparkle";
import PlusIcon from "../../components/PlusIcon/PlusIcon";
import Tooltip from "../../components/Tooltip/Tooltip";
import Loading from "../Loading/Loading";
import { LoadingContext } from "../../contexts/LoadingContext";
import FoldedPopup from "../../components/FoldedPopup/FoldedPopup";
import CTAButton from "../../components/CTAButton/CTAButton";
import CustomSchedulePopup from "../../components/CustomSchedulePopup/CustomSchedulePopup";
import CrunchTimeBar from "../../components/StudyPlanPopups/CrunchTimeBar/CrunchTimeBar";
import CrunchTimeLabel from "../../components/StudyPlanPopups/CrunchTimeBar/CrunchTimeLabel/CrunchTimeLabel";
import CustomScheduleBanner from "../../components/CustomScheduleBanner/CustomScheduleBanner";
import EditCustomSchedulePopup from "../../components/EditCustomSchedulePopup/EditCustomSchedulePopup.jsx";
import StudyTutorial from "../../components/Tutorials/StudyTutorial.jsx";
import SampleData from "../../components/SampleData/SampleData.jsx";
import QuizzyPlusTutorial from "../../components/Tutorials/QuizzyPlusTutorial.jsx";

function Study(props) {
  // addStyles();
  var currentFlipCardRef = useRef();
  const [slideDirection, setSlideDirection] = useState(null);
  const navigate = useNavigate();
  const { speak, cancel, voices } = useSpeechSynthesis();
  const selectedVoiceIndex = 1;

  const [customSchedulePopupEnabled, setCustomSchedulePopupEnabled] =
    useState(false);
  const [editCustomSchedulePopupEnabled, setEditCustomSchedulePopupEnabled] =
    useState(false);
  const [quizScheduledPopupEnabled, setQuizScheduledPopupEnabled] =
    useState(true);
  const [recallScheduledPopupEnabled, setRecallScheduledPopupEnabled] =
    useState(true);
  const [startDateFriendsRecallProgress, setStartDateFriendsRecallProgress] =
    useState(new Date(new Date().setDate(new Date().getDate() - 7)));

  const [user, setUser] = useState({
    name: "",
    streak: 0,
    today: { pending: 0, completed: 0, streak_saved: 0 },
    streak_calendar: { this_month: [] },
    email_verified: true,
  });
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [asyncOperationCount, setAsyncOperationCount] = useState(0);

  // Custom function to increment the counter
  const startAsyncOperation = () => {
    setAsyncOperationCount((prevCount) => prevCount + 1);
    if (!isLoading) setIsLoading(true);
  };

  // Custom function to decrement the counter
  const finishAsyncOperation = () => {
    setAsyncOperationCount((prevCount) => {
      const newCount = prevCount - 1;
      if (newCount === 0) setIsLoading(false);
      return newCount;
    });
  };

  useEffect(() => {
    setIsLoading(true);
    startAsyncOperation();
    get_user((user) => {
      setUser(user);
      finishAsyncOperation();
    });
    startAsyncOperation();
    get_recall_results(setid, (d) => {
      setLRMData(d.lrm_data);
      setLRMHistory(d.lrm_history[0]);
      setLRMHistoryLabels(d.lrm_history[1]);
      finishAsyncOperation();
    });
    startAsyncOperation();
    get_set_data(setid, token, function (data) {
      if (!data["title"] || data["success"] === false) {
        window.location.href = "https://quizzynow.com/404";
      }
      setSetData(data);
      var eTitle = !data["title"]
        ? "ERROR"
        : data["title"].replace(/\s+/g, "-").toLowerCase();

      setExpectedTitle(encodeURIComponent(eTitle));
      var front_img = data.terms[0][2];
      var back_img = data.terms[0][3];
      var front_equation = data.terms[0][4];
      var back_equation = data.terms[0][5];
      setCurrentCard({
        front: data.terms[0][0],
        back: data.terms[0][1],
        num: 0,
        nterms: data.terms.length,
        front_img: front_img,
        back_img: back_img,
        front_equation: front_equation,
        back_equation: back_equation,
        is_mdt: data?.psd?.most_difficult_terms[0] !== undefined,
      });
      for (var key in data?.psd?.most_difficult_terms) {
        if (data?.psd?.most_difficult_terms[key] > highestMissedTermIndex) {
          setHighestMissedTermIndex(data?.psd?.most_difficult_terms[key]);
        }
      }
      if (data?.psd?.most_difficult_terms) {
        setMostDifficultTerms(data?.psd?.most_difficult_terms);
      } else {
        if (data.terms.length > 3) {
          setMostDifficultTerms([9, 6]);
        } else {
          setMostDifficultTerms([9, 6, 2]);
        }
      }
      ReactGA.event({
        category: "User",
        action: "Viewed Study Set",
        label: "Viewed Set " + data["title"],
      });
      finishAsyncOperation();
      document.title = data["title"] + " - Quizzy";
    });
    //startAsyncOperation();
    get_friends_most_difficult_terms(setid, (d) => {
      setFriendsMostDifficultTerms(d["friends_most_difficult_terms"]);
      setMyMDTsFriendsAssociation(d["my_mdts_friend_association"]);
      setExtremelyMostDifficultTerm(d["extremely_most_missed_term_info"]);
      setFriendsRecallProgress(d["friends_recall_progress"]);
      var leaderboardKeys = Object.keys(d["leaderboard"]);
      leaderboardKeys.sort((a, b) => {
        if (d["leaderboard"][a] > d["leaderboard"][b]) {
          return -1;
        } else if (d["leaderboard"][a] < d["leaderboard"][b]) {
          return 1;
        }
        return 0;
      });
      setLeaderboard(d["leaderboard"]);
      setLeaderboardKeys(leaderboardKeys);
      setSelectedFriendComparison(
        leaderboardKeys.filter((key) => key != user.username)[0]
      );
      //finishAsyncOperation();
    });
  }, []);

  const setDateInput = useRef(null);
  const [slideleft, setSlideLeft] = useState(0);
  const [slideright, setSlideRight] = useState(0);

  const [appear, setAppear] = useState(0);

  const [selectedFriendComparison, setSelectedFriendComparison] =
    useState(null);
  const [crunchTimePopupEnabled, setCrunchTimePopupEnabled] = useState(false);

  const [LRMData, setLRMData] = useState([]);
  const [LRMHistory, setLRMHistory] = useState([]);
  const [LRMHistoryLabels, setLRMHistoryLabels] = useState([]);
  const [mostDifficultTerms, setMostDifficultTerms] = useState([]);
  const [friendsMostDifficultTerms, setFriendsMostDifficultTerms] = useState(
    []
  );
  const [myMDTsFriendsAssociation, setMyMDTsFriendsAssociation] = useState([]);
  const [extremelyMostDifficultTerm, setExtremelyMostDifficultTerm] = useState(
    []
  );
  const [friendsRecallProgress, setFriendsRecallProgress] = useState([]);

  const [soundEnabled, setSoundEnabled] = useState(false);
  const pen = useRef(null);
  const { setid, title } = useParams("");
  const [setdata, setSetData] = useState({
    title: "",
    terms: {},
    test: {},
    creator: {},
    tags: [],
    creation_date: null,
    psd: {
      study_history_by_activity: {},
      study_time_distribution: {},
      time_spent_on_learning: {},
      recall_progress: [[], []],
      mastery_progress: [[], []],
      most_difficult_terms: [],
    },
  });

  useEffect(() => {
    if (setdata && setdata.title) {
      setIsLoading(false);
    }
  }, [setdata]);

  const [expectedTitle, setExpectedTitle] = useState(null);
  const [currentCard, setCurrentCard] = useState({
    front: "",
    back: "",
    front_img: null,
    back_img: null,
    front_equation: null,
    back_equation: null,
    num: -1,
  });
  const [genericQuizzyPlusPopupEnabled, setGenericQuizzyPlusPopupEnabled] =
    useState(false);
  const [addTaskVisible, setAddTaskVisible] = useState(false);
  const [leaderboardKeys, setLeaderboardKeys] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const token = get_session_token();
  const tags = setdata.tags;
  const isTouchDevice =
    "maxTouchPoints" in navigator &&
    navigator.maxTouchPoints > 0 &&
    /(iPhone|iPad|Android|webOS|BlackBerry|Windows Phone|Opera Mini|IEMobile)/i.test(
      navigator.userAgent
    );

  const [highestMissedTermIndex, setHighestMissedTermIndex] = useState(0);

  var urlTitle = "";

  const getTotalProgress = (learningTerms, reviewingTerms, learnedTerms) => {
    let totalTerms = learningTerms + reviewingTerms + learnedTerms;

    return (reviewingTerms * 0.5) / totalTerms + learnedTerms / totalTerms;
  };

  const useNavigationEffect = (callback) => {
    const location = useLocation();

    useEffect(() => {
      // This function will be called when the component is unmounted or the page is refreshed/closed
      const handleRouteChange = () => {
        callback();
      };

      // Add the event listener for beforeunload
      window.addEventListener("beforeunload", handleRouteChange);

      // Clean up when the component is unmounted
      return () => {
        window.removeEventListener("beforeunload", handleRouteChange);
        handleRouteChange(); // Call the callback function when the component is unmounted
      };
    }, []); // Remove 'location' and 'callback' from the dependency array
  };

  useNavigationEffect(() => {
    on_set_closed(setid, "flashcards", token, () => {});
  });

  useEffect(() => {
    {
      /*get_tutorial_progress("study", (data) => {
      if (data["success"] !== undefined) {
        setStudyTutorialPhase(data["phase"]);
        setStudyTutorialStepIndex(data["step_index"]);
        setStudyTutorialEnabled(true);
      }
    });*/
    }
    get_tutorial_progress("quizzyplus", (data) => {
      if (data["success"] !== undefined) {
        setQuizzyPlusStudyTutorialPhase(data["phase"]);
        setQuizzyPlusStudyTutorialStepIndex(data["step_index"]);
        setQuizzyPlusStudyTutorialEnabled(true);
      }
    });
  }, []);

  urlTitle = "/study/" + setid + "/" + expectedTitle;

  var recallDates = [];
  if (setdata !== undefined && setdata?.psd?.recall_dates !== undefined) {
    setdata.psd.recall_dates.map((date, index) => {
      if (index <= 4) {
        recallDates.push(new Date(date));
      }
    });
  }

  if (expectedTitle != null && encodeURIComponent(title) !== expectedTitle) {
    navigate(urlTitle);
  }

  function setCardIndex(ind) {
    let n = ind;
    if (n == 0 || n == setdata.terms.length - 1) {
      return;
    }

    setCurrentCard({
      front: setdata.terms[n + 1][0],
      back: setdata.terms[n + 1][1],
      front_img: setdata.terms[n + 1][2],
      back_img: setdata.terms[n + 1][3],
      front_equation: setdata.terms[n + 1][4],
      back_equation: setdata.terms[n + 1][5],
      num: n + 1,
      is_mdt: setdata.psd?.most_difficult_terms[n + 1] !== undefined,
    });
    setAppear(1);
  }

  function onLeftArrowClicked() {
    var n = currentCard.num;
    if (n == 0) {
      return;
    }
    setSlideDirection("right");
    setSlideRight(1);
  }

  function onRightArrowClicked() {
    var n = currentCard.num;
    if (n == setdata.terms.length - 1) {
      return;
    }
    setSlideDirection("left");
    setSlideLeft(1);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = new Date().toLocaleString("en-US", {
    month: "long",
  });

  const [studyTutorialEnabled, setStudyTutorialEnabled] = useState(false);
  const [studyTutorialPhase, setStudyTutorialPhase] = useState(0);
  const [studyTutorialStepIndex, setStudyTutorialStepIndex] = useState(0);
  const [quizzyPlusStudyTutorialEnabled, setQuizzyPlusStudyTutorialEnabled] =
    useState(false);
  const [quizzyPlusStudyTutorialPhase, setQuizzyPlusStudyTutorialPhase] =
    useState(0);
  const [
    quizzyPlusStudyTutorialStepIndex,
    setQuizzyPlusStudyTutorialStepIndex,
  ] = useState(0);

  var [todayISO] = new Date().toISOString().split("T");

  const COLORS = [
    "#E85871",
    "#8358E8",
    "#58AEE8",
    "#58E8D4",
    "#58E866",
    "#E8E858",
    "#E88458",
    "#5883E8",
    "#58E8E3",
    "#58E8A5",
    "#4D4D4D",
    "#86A8E7",
  ];

  const isMobile = () => {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  };

  var studyTimeDistrib = {
    labels: [],
    data: [],
    bgColor: COLORS,
    textInside: "0",
    rotate: -45,
    divider: 2.6,
    minFontSize: isMobile() ? 10 : 20,
    maxFontSize: isMobile() ? 14 : 22,
  };

  var masteryProg = {
    labels: ["Mastery Progress", "NaN"],
    data: [0, 100],
    bgColor: ["#8358E8", "#363636"],
    textInside: "0%",
    rotate: -45,
    mastery: true,
    divider: 2.6,
    minFontSize: isMobile() ? 10 : 20,
    maxFontSize: isMobile() ? 14 : 22,
  };

  var recallProg = {
    fill: [
      {
        title: "Reviewing",
        data: [],
        color: "#7B7B7B",
      },
      {
        title: "Learned",
        data: [],
        color: "#58E892",
      },
    ],
    labels: [],
    /*plugins: {
      testDate: {
        id: "testDate",
        beforeDatasetsDraw(chart, args, pluginOptions) {
          const {ctx, data, chartArea: { left, right, top, bottom, width, height}, scales: {x, y}} = chart; 
          ctx.save();
          ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
          ctx.fillRect(x, top, y, height);
          ctx.restore();
          
        }
      }
    }*/
  };

  var myLearningProgress = {
    labels: [],
    fill: [
      {
        title: "Your Learning",
        data: [],
        color: "#8358e8",
      },
    ],
  };

  var friendsRecallProg = {
    fill: [],
    labels: [],
    /*elements: {
      point: {
        pointStyle: [pointImage, "circle", "triangle", pointImage],
      },
    },*/
  };
  // Function to add days to a date
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  // Function to format date in 'MM/DD/YYYY' format
  function formatDate(date) {
    var month = date.getMonth() + 1; // getMonth() returns 0-11
    var day = date.getDate();
    var year = date.getFullYear();
    // Pad month and day with leading zero if they are less than 10
    var formattedMonth = month < 10 ? "0" + month : month;
    var formattedDay = day < 10 ? "0" + day : day;
    return formattedMonth + "/" + formattedDay + "/" + year;
  }

  // Function to generate a list of all dates in the range
  function getAllDates(startDate, endDate) {
    var dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate)); // Push Date object
      currentDate = addDays(currentDate, 1);
    }
    return dates;
  }

  function sortUserProgressByDate(userProgress) {
    // Convert object into an array of [date, value] pairs
    const entries = Object.entries(userProgress);

    // Sort the array by date
    entries.sort((a, b) => {
      // Convert date strings into date objects for comparison
      const dateA = new Date(a[0]);
      const dateB = new Date(b[0]);
      return dateA - dateB;
    });

    const sortedUserProgress = {};
    entries.forEach(([date, value]) => {
      sortedUserProgress[date] = value;
    });

    return sortedUserProgress;
  }

  function updateFriendsRecallProgressChartRange(selectedRange) {
    var startDate,
      endDate = new Date();

    switch (selectedRange) {
      case "today":
        startDate = new Date();
        break;
      case "this_week":
        startDate = new Date(
          endDate.setDate(endDate.getDate() - endDate.getDay())
        );
        break;
      case "this_month":
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        break;
      case "this_year":
        startDate = new Date(endDate.getFullYear(), 0, 1);
        break;
      case "lifetime":
        // Find the earliest date from friendsRecallProgress
        startDate = new Date(
          Math.min(
            ...Object.values(friendsRecallProgress).flatMap((user) =>
              Object.keys(user[0]).map((dateStr) => new Date(dateStr))
            )
          )
        );
        break;
      default:
        // If the range is somehow undefined, default to 'lifetime'
        startDate = new Date(
          Math.min(
            ...Object.values(friendsRecallProgress).flatMap((user) =>
              Object.keys(user[0]).map((dateStr) => new Date(dateStr))
            )
          )
        );
    }

    setStartDateFriendsRecallProgress(startDate);
  }

  /*
  var earliestDate = new Date();
  Object.keys(friendsRecallProgress).forEach(username => {
    var userProgressDates = Object.keys(friendsRecallProgress[username][0]);
    userProgressDates.forEach(dateStr => {
      var date = new Date(dateStr);
      if (date < earliestDate) {
        earliestDate = date;
      }
    });
  });*/

  // Now we have the earliest date, let's populate the labels

  var allLabels = getAllDates(startDateFriendsRecallProgress, new Date());
  friendsRecallProg.labels = allLabels.map((date) => formatDate(date));

  // Now let's populate the data for each friend
  Object.keys(friendsRecallProgress).forEach((username) => {
    var imageSize = isMobile() ? 15 : 25;
    var pointImage = new Image(imageSize, imageSize);
    pointImage.src = friendsRecallProgress[username][2];
    if (friendsRecallProgress[username] && friendsRecallProgress[username][0]) {
      var userProgress = sortUserProgressByDate(
        friendsRecallProgress[username][0]
      );

      var fillPush = {
        title: username,
        data: [],
        pointStyle: [],
        color: username === user.username ? "#8358E8" : undefined,
      };

      // Let's iterate over all labels and match them with userProgress data points
      friendsRecallProg.labels.forEach((label, index) => {
        var dataPoint = userProgress[label];
        var isLastPoint = index === friendsRecallProg.labels.length - 1;

        if (dataPoint !== undefined) {
          fillPush.data.push(dataPoint);
        } else {
          fillPush.data.push(fillPush.data[fillPush.data.length - 1] || 0);
        }

        fillPush.pointStyle.push(isLastPoint ? pointImage : "circle");
      });

      friendsRecallProg.fill.push(fillPush);
    }
  });

  friendsRecallProg.labels.sort(function (x, y) {
    let pattern = /([\d]+)\/([\d]+)\/([\d]+)/;
    let match1 = x.match(pattern);
    let month1 = parseInt(match1[1], 10);
    let day1 = parseInt(match1[2], 10);
    let year1 = parseInt(match1[3], 10);

    let match2 = y.match(pattern);
    let month2 = parseInt(match2[1], 10);
    let day2 = parseInt(match2[2], 10);
    let year2 = parseInt(match2[3], 10);

    if (year1 !== year2) {
      return year1 - year2;
    }
    if (month1 !== month2) {
      return month1 - month2;
    }
    return day1 - day2;
  });

  const generateDateRange = (startDate, endDate) => {
    let dates = [];
    let current = new Date(startDate);
    let end = new Date();

    if (endDate != null) {
      end = new Date(endDate);
    }

    // Check if start and end dates are the same
    if (current.toDateString() === end.toDateString()) {
      dates.push(formatDate(current));
      return dates;
    }

    end.setDate(end.getDate() + 1); // Include the end date

    while (current <= end) {
      dates.push(formatDate(current));
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  // Generate Date Range
  let endDate = null; //today

  if (setdata?.psd?.test && setdata?.psd?.test.test_date != undefined) {
    endDate = setdata.psd.test.test_date;
  }

  const dateRange = generateDateRange(LRMHistoryLabels[0], endDate);

  recallProg.labels = dateRange;

  const alignAndPersistData = (dateRange, LRMHistory) => {
    let alignedData = [];
    let lastKnownValue = 0; // Initialize to 0 or another default as needed
    const today = new Date();

    dateRange.forEach((dateLabel) => {
      const date = new Date(dateLabel);
      if (date <= today) {
        if (LRMHistory && LRMHistory.hasOwnProperty(dateLabel)) {
          lastKnownValue = LRMHistory[dateLabel];
        }
        alignedData.push(lastKnownValue);
      } else {
        // For future dates, don't push any data
        alignedData.push(null); // Or you can leave it undefined, depending on how you want to handle it
      }
    });

    return alignedData;
  };

  // Align and persist data for both reviewing and learning datasets
  let reviewingData = alignAndPersistData(dateRange, LRMHistory[0], 0);
  let learningData = alignAndPersistData(dateRange, LRMHistory[1], 1);

  // Assuming recallProg.fill[0] is for reviewing and recallProg.fill[1] is for learning
  recallProg.fill[0].data = reviewingData;
  recallProg.fill[1].data = learningData;

  if (setdata?.psd?.test && setdata?.psd?.test?.test_date) {
    const testDate = setdata?.psd?.test?.test_date;
    const testDateLabelFormatted = formatDate(new Date(testDate));
    const todayDateLabelFormatted = formatDate(new Date()); // Format today's date similar to other labels

    recallProg.annotations = {
      test_date: {
        type: "line",
        xMin: testDateLabelFormatted,
        xMax: testDateLabelFormatted,
        yMin: 0,
        yMax: "max",
        backgroundColor: "rgba(255, 91, 145, 0.5)",
        borderColor: "rgba(255, 91, 145, 0.5)", // Red color for Test Date
        label: {
          display: true,
          content: `Test Date`,
          backgroundColor: "rgba(255, 91, 145, 0.5)",
          xAdjust: -30, // Adjust along x-axis to prevent overlap
          yAdjust: 15, // Adjust along y-axis to prevent overlap
          font: {
            family: "Plus Jakarta Sans",
            weight: 600,
            size: 16,
          },
        },
      },
      today: {
        type: "line",
        xMin: todayDateLabelFormatted,
        xMax: todayDateLabelFormatted,
        yMin: 0,
        yMax: "max",
        backgroundColor: "rgba(54, 162, 235, 0.5)", // Choose a distinct color for today
        borderColor: "rgba(54, 162, 235, 0.5)", // Same color for the border
        label: {
          display: true,
          content: `Today`,
          backgroundColor: "rgba(54, 162, 235, 0.5)",
          xAdjust: -30, // Adjust to prevent overlap with other elements
          yAdjust: 15, // Same here
          font: {
            family: "Plus Jakarta Sans",
            weight: 600,
            size: 16,
          },
        },
      },
    };
  }

  var mastery_prog = setdata?.psd?.mastery_progress;
  masteryProg.data = [mastery_prog, 1 - mastery_prog];

  masteryProg.textInside = Math.floor(mastery_prog * 100) + "%";

  for (var key in setdata?.psd?.study_time_distribution?.std) {
    if (setdata?.psd?.study_time_distribution?.std?.hasOwnProperty(key)) {
      studyTimeDistrib.labels.push(key);
      studyTimeDistrib.data.push(setdata.psd.study_time_distribution.std[key]);
    }
  }

  var timeSpentOnLearning = {
    labels: [],
    datasets: [],
  };

  var time_spent_on_learning = setdata?.psd?.time_spent_on_learning;
  var increment = 0;

  // Initialize an empty object to store normalized data
  var normalizedData = {};

  // Iterate over each dataset in time_spent_on_learning
  for (var setName in time_spent_on_learning) {
    // Initialize an empty object for the dataset
    normalizedData[setName] = {};

    var timestamps = Object.keys(time_spent_on_learning[setName]);

    // Parse timestamps into Date objects
    var parsedTimestamps = timestamps.map((ts) =>
      parse(ts, "hh:mm aa", new Date())
    );

    // Find the earliest and latest timestamps
    var earliestTimestamp = Math.min(...parsedTimestamps);
    var latestTimestamp = Math.max(...parsedTimestamps);

    // Generate a list of all minute intervals between the earliest and latest timestamps
    var allMinutes = eachMinuteOfInterval({
      start: earliestTimestamp,
      end: latestTimestamp,
    });

    // Iterate over each minute in the interval
    allMinutes.forEach((minute) => {
      // Format the minute back into a string
      var formattedMinute = format(minute, "hh:mm aa");

      // If this minute exists in the original data, use that value, otherwise use 0
      normalizedData[setName][formattedMinute] =
        time_spent_on_learning[setName][formattedMinute] || 0;
    });
  }

  // Replace time_spent_on_learning with normalizedData
  time_spent_on_learning = normalizedData;
  // Create a helper function to convert 12-hour time format to 24-hour format
  function convertTo24Hour(time) {
    let [_, hour, minute, period] = time.match(/([\d]+):([\d]+) ([\w]+)/);
    hour = parseInt(hour);
    if (period === "PM" && hour < 12) hour += 12;
    else if (period === "AM" && hour === 12) hour = 0;
    return hour * 60 + parseInt(minute);
  }

  let timeIndexMap = {};

  for (let setName in time_spent_on_learning) {
    let data = Array(timeSpentOnLearning.labels.length).fill(0);

    for (let timeStamp in time_spent_on_learning[setName]) {
      if (!timeSpentOnLearning.labels.includes(timeStamp)) {
        timeSpentOnLearning.labels.push(timeStamp);
        timeIndexMap[timeStamp] = timeSpentOnLearning.labels.length - 1;
      }
      data[timeIndexMap[timeStamp]] =
        time_spent_on_learning[setName][timeStamp];
    }

    timeSpentOnLearning.datasets.push({
      label: setName,
      data: data,
      borderColor: COLORS[increment],
      backgroundColor: COLORS[increment],
      lineTension: 0,
      fill: false,
      stepped: true,
      pointRadius: 0,
    });
    increment++;
  }

  // Convert all times to 24-hour format and sort
  timeSpentOnLearning.labels.sort(
    (x, y) => convertTo24Hour(x) - convertTo24Hour(y)
  );
  const tot = setdata?.psd?.study_time_distribution?.total;
  function calculateBarWidth(missedCount) {
    const maxWidth = 100; // maximum width of the bar in pixels
    const minWidth = 20; // minimum width of the bar in pixels
    const maxMissed = 10; // adjust this based on your maximum expected missed count

    let width = (missedCount / maxMissed) * (maxWidth - minWidth) + minWidth;
    return `${width}px`;
  }

  function FriendComparison() {
    var leaderKeys = leaderboardKeys;
    var selectedFriendComp = selectedFriendComparison;
    var friendsRecallProg = friendsRecallProgress;
    var friendsMDTs = friendsMostDifficultTerms;
    var sampleFriendsRecallProg = [0, 1];

    if (!user?.plans?.analytics) {
      leaderKeys = ["Friend 1", "Friend 2", "Friend 3"];
      selectedFriendComp = 0;

      if (setdata?.terms.length > 2) {
        sampleFriendsRecallProg = [0, 1, 2];
      }
      friendsRecallProg = [
        [
          [sampleFriendsRecallProg],
          "Friend 1",
          "https://quizzynow.com/uploads/avatars/default_avatars/f_1.png",
          "offline",
          1,
        ],
      ];
      friendsMDTs = {
        [1]: [sampleFriendsRecallProg],
      };
    }
    return (
      <section className="friend-comparison">
        <div className="friend-comparison-title">
          <h3>Friend Comparison</h3>
          <AnalyticsBadge></AnalyticsBadge>
        </div>

        <p className="label">
          {leaderboardKeys.filter((username) => username != user.username)
            .length > 0
            ? "See how you're doing compared to certain friends"
            : "Invite some friends to study this set and compare with them"}
        </p>

        <>
          {leaderKeys.filter((username) => username !== user.username).length >
            0 && (
            <div className="select-friend-cover">
              <p className="label">Select Friend</p>
              <select
                name="term"
                id="term"
                onChange={(e) => {
                  setSelectedFriendComparison(e.target.value);
                }}
              >
                {leaderKeys
                  .filter((username) => username !== user.username)
                  .map((username) => (
                    <option value={username}>{username} </option>
                  ))}
              </select>
            </div>
          )}
          {selectedFriendComp != undefined &&
            selectedFriendComp != null &&
            friendsMDTs != undefined && (
              <section className="difficult-terms-distribution">
                <div className="difficult-terms-distribution-title">
                  <h3>Difficult Terms Distribution</h3>
                  <AnalyticsBadge></AnalyticsBadge>
                </div>
                {user?.plans?.analytics != undefined && (
                  <p className="label">
                    {friendsMDTs[friendsRecallProg[selectedFriendComp][4]] ===
                    undefined
                      ? selectedFriendComp +
                        " does not have any data to display for this set."
                      : "See which terms are the most difficult for you and your friends."}
                  </p>
                )}

                {friendsMDTs[friendsRecallProg[selectedFriendComp][4]] !=
                  undefined && (
                  <div className="venn-diagram">
                    <div className="left">
                      <div className="selected-friend-info">
                        <div className="avatar-wrap">
                          <img
                            className="avatar"
                            alt="avatar"
                            src={user.image}
                          ></img>
                          <div className={"status " + user.status}></div>
                        </div>
                        <p className="label">You</p>
                      </div>

                      <div className="diagram diagram-left">
                        <div className="venn-most-difficult-terms">
                          {Object.keys(mostDifficultTerms).map((key) => (
                            <div className="label" id="mdts-hint-text">
                              {setdata.terms[key][4] == null ? (
                                <h5>{setdata.terms[key][0]}</h5>
                              ) : (
                                <StaticMathField>
                                  {setdata.terms[key][0]}
                                </StaticMathField>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="both">
                      <p className="label both-label">Both</p>
                      <div className="diagram diagram-middle">
                        <div className="venn-most-difficult-terms">
                          {Object.keys(mostDifficultTerms)
                            .filter((k) => {
                              return (
                                friendsMDTs[
                                  friendsRecallProg[selectedFriendComp][4]
                                ] != undefined &&
                                friendsMDTs[
                                  friendsRecallProg[selectedFriendComp][4]
                                ][0][k]
                              );
                            })
                            .map((key) => (
                              <div className="label">
                                {setdata.terms[key][4] == null ? (
                                  <h5>{setdata.terms[key][0]}</h5>
                                ) : (
                                  <StaticMathField>
                                    {setdata.terms[key][0]}
                                  </StaticMathField>
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>

                    <div className="right">
                      <Link
                        className="selected-friend-info"
                        to={
                          "https://quizzynow.com/users/" +
                          friendsMDTs[friendsRecallProg[selectedFriendComp][4]]
                        }
                      >
                        <div className="avatar-wrap">
                          <img
                            className="avatar"
                            alt="avatar"
                            src={friendsRecallProg[selectedFriendComp][2]}
                          ></img>
                          <div
                            className={
                              "status " +
                              friendsRecallProg[selectedFriendComp][3]
                            }
                          ></div>
                        </div>
                        <p className="label avatar-name">
                          {friendsRecallProg[selectedFriendComp][1]}
                        </p>
                      </Link>
                      <div className="diagram diagram-right">
                        <div className="venn-most-difficult-terms">
                          {friendsMDTs[
                            friendsRecallProg[selectedFriendComp][4]
                          ] &&
                            Object.keys(
                              friendsMDTs[
                                friendsRecallProg[selectedFriendComp][4]
                              ][0]
                            ).map((key) => (
                              <div className="label">
                                {setdata.terms[key][4] == null ? (
                                  <h5>{setdata.terms[key][0]}</h5>
                                ) : (
                                  <StaticMathField>
                                    {setdata.terms[key][0]}
                                  </StaticMathField>
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </section>
            )}
        </>
      </section>
    );
  }
  function MostDifficultTerms() {
    return (
      <section className="most-difficult-terms">
        <div className="most-difficult-terms-title">
          <h3>Most Difficult Terms</h3>
          <PlusIcon big={true} />
        </div>

        <p className="label">
          {Object.keys(setdata.psd.most_difficult_terms).length > 0
            ? "View your most difficult terms, and see who else is struggling with them"
            : "Try a Recall Session or Quiz, and you'll see your Most Difficult Terms here."}
        </p>
        <>
          <div className="most-missed">
            {
              <div className="chart">
                <div
                  className="labels"
                  style={
                    {
                      // marginTop: Object.keys(quizDetails[2]).length * 5 + "px",
                    }
                  }
                >
                  {Object.keys(mostDifficultTerms).map(
                    (key) =>
                      setdata.terms[key] != null && (
                        <div className="term-bar-container">
                          {myMDTsFriendsAssociation[key] !== undefined && (
                            <Link
                              to={`/users/${myMDTsFriendsAssociation[key][0]}`}
                            >
                              <img
                                className="avatar"
                                src={myMDTsFriendsAssociation[key][1]}
                                alt="User Avatar"
                              />
                            </Link>
                          )}
                          {setdata.terms[key][4] == null ? (
                            <h5>{setdata.terms[key][0]}</h5>
                          ) : (
                            <StaticMathField>
                              {setdata.terms[key][0]}
                            </StaticMathField>
                          )}{" "}
                          <div className="bar-container">
                            <div
                              className="bar"
                              style={{
                                width: calculateBarWidth(
                                  mostDifficultTerms[key]
                                ),
                                backgroundColor: getMostMissedColor(
                                  mostDifficultTerms[key],
                                  highestMissedTermIndex > 0
                                    ? highestMissedTermIndex
                                    : Object.keys(setdata.terms).length
                                ),
                              }}
                            ></div>
                          </div>
                        </div>
                      )
                  )}
                </div>
              </div>
            }
          </div>
          {!extremelyMostDifficultTerm[0] &&
            !setdata.terms[extremelyMostDifficultTerm[0]] &&
            !extremelyMostDifficultTerm[1] &&
            extremelyMostDifficultTerm[0] !== undefined && (
              <p className="label struggling-with-hint-text">
                You and{" "}
                <img
                  className="avatar"
                  alt="struggling friend avatar"
                  src={extremelyMostDifficultTerm[2]}
                ></img>
                {extremelyMostDifficultTerm[1]} are struggling with the term{" "}
                <span style={{ fontWeight: "bold" }}>
                  {setdata.terms[extremelyMostDifficultTerm[0]][0]}
                </span>
              </p>
            )}
        </>
      </section>
    );
  }

  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " mins " : " mins ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " secs" : " secs") : "";

    if (mDisplay != "") {
      hDisplay = h + "hrs ";
      mDisplay = m + "m ";
      if (s > 0) {
        sDisplay = s + "s";
      }
    }
    return hDisplay + mDisplay + sDisplay;
  }

  studyTimeDistrib.textInside = tot > 0 ? secondsToHms(tot) : "0 hours";

  if (tot <= 0) {
    studyTimeDistrib.labels = ["Empty"];
    studyTimeDistrib.data = [24 * 60 * 60];
    studyTimeDistrib.bgColor = ["#363636"];
  }

  const addZero = (num) => (num >= 10 ? num : "0" + num);

  const stringifyDate = (rawDate, includeYear = false, monthString = false) => {
    // Adjusting for time zone
    const date =
      rawDate instanceof Date ? rawDate : new Date(rawDate + "T00:00:00");

    const day = date.getDate();
    const month = addZero(date.getMonth() + 1);
    const year = date.getFullYear();

    if (monthString) {
      return `${months[date.getMonth()]} ${day}`;
    }

    return `${month}/${day}${
      includeYear ? `/${year.toString().substr(2)}` : ""
    }`;
  };

  const getItemTypeAssignedToday = (schedule) => {
    if (!setdata.id) return false;

    var filteredSchedule = schedule?.filter((scheduleItem) => {
      if (!scheduleItem) return false;

      let scheduleItemTimeStamp = new Date(scheduleItem.timestamp);
      let scheduleItemSetId = scheduleItem.id;
      let setDataId = setdata.id;
      let now = new Date();

      return scheduleItemSetId == setDataId && now > scheduleItemTimeStamp;
    });

    if (filteredSchedule?.length > 0) {
      return filteredSchedule[0].type;
    }
    return null;
  };

  const formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
  };

  /*if (expectedTitle != null && title != expectedTitle) {
    return <Navigate to={urlTitle}></Navigate>;
  }
  if (expectedTitle == "ERROR") {
    return <Navigate to="/404"></Navigate>;
  }*/
  if (expectedTitle === "ERROR") {
    return <Navigate to="/404"></Navigate>;
  }

  const creator_url = "/users/" + setdata.creator.userid; //+ "/" + setdata.creator.username

  return isLoading ? (
    <Loading />
  ) : (
    <>
      {setdata.title.length > 0 && (
        <AddTask
          user={user}
          visible={addTaskVisible}
          setVisible={setAddTaskVisible}
          setsOverride={[
            {
              title: setdata?.title,
              terms: setdata?.terms,
              id: setdata?.id,
              description: setdata?.description,
            },
          ]}
          taskOverride={1}
          stageOverride={2}
        ></AddTask>
      )}

      {studyTutorialEnabled && !isLoading && (
        <StudyTutorial
          phase={studyTutorialPhase}
          setPhase={setStudyTutorialPhase}
          user={user}
          slideLeft={slideleft}
          setStepIndex={setStudyTutorialStepIndex}
          stepIndex={studyTutorialStepIndex}
        ></StudyTutorial>
      )}

      {quizzyPlusStudyTutorialEnabled &&
        !isLoading &&
        !studyTutorialEnabled && (
          <QuizzyPlusTutorial
            phase={quizzyPlusStudyTutorialPhase}
            setPhase={setQuizzyPlusStudyTutorialPhase}
            user={user}
            stepIndex={quizzyPlusStudyTutorialStepIndex}
            setStepIndex={setQuizzyPlusStudyTutorialStepIndex}
          ></QuizzyPlusTutorial>
        )}

      <CustomSchedulePopup
        user={user}
        setid={setdata?.id}
        lrm_data={LRMData}
        term_count={setdata?.terms.length}
        setCustomSchedulePopupEnabled={setCustomSchedulePopupEnabled}
        customSchedulePopupEnabled={customSchedulePopupEnabled}
        title={setdata?.title}
      ></CustomSchedulePopup>

      {setdata?.psd?.test?.test_date && setdata?.study_plan?.often_value && (
        <EditCustomSchedulePopup
          user={user}
          setid={setdata?.id}
          lrm_data={LRMData}
          setdata={setdata}
          term_count={setdata?.terms.length}
          setEditCustomSchedulePopupEnabled={setEditCustomSchedulePopupEnabled}
          editCustomSchedulePopupEnabled={editCustomSchedulePopupEnabled}
          title={setdata?.title}
        ></EditCustomSchedulePopup>
      )}

      {setdata?.study_plan &&
        setdata?.study_plan?.shown_crunch_popup != undefined &&
        setdata?.study_plan?.shown_crunch_popup === 0 && (
          <CrunchTimePopup user={user}></CrunchTimePopup>
        )}

      <div className="study">
        <main>
          {/* Top Section */}

          <Popup
            enabled={genericQuizzyPlusPopupEnabled}
            setEnabled={setGenericQuizzyPlusPopupEnabled}
            variant="genericQuizzy+Popup"
            title="Upgrade to Quizzy+ for this feature!"
            subtitle={"This feature is only available to Quizzy+ users."}
          ></Popup>

          {!quizzyPlusStudyTutorialEnabled &&
            !studyTutorialEnabled &&
            getItemTypeAssignedToday(user?.schedule) === "Quiz" && (
              <FoldedPopup
                noImage={true}
                closeButton={true}
                enabled={quizScheduledPopupEnabled}
                setEnabled={setQuizScheduledPopupEnabled}
                className="quiz-scheduled-popup"
              >
                <h1>You have a Quiz scheduled for this set right now.</h1>
                <p>
                  A scheduled Quiz is available for you to take now. Take it to
                  stay on track on learning all the terms in time.
                </p>
                <CTAButton
                  text="Take me there"
                  color="purple"
                  onClick={() => {
                    let currentPath = window.location.pathname;
                    if (currentPath.endsWith("/")) {
                      currentPath = currentPath.slice(0, -1);
                    }

                    navigate(`${currentPath}/quiz`);
                  }}
                ></CTAButton>

                <p
                  className="no-thanks"
                  onClick={() => {
                    setQuizScheduledPopupEnabled(false);
                  }}
                >
                  No thanks
                </p>
              </FoldedPopup>
            )}
          {!quizzyPlusStudyTutorialEnabled &&
            !studyTutorialEnabled &&
            getItemTypeAssignedToday(user?.schedule) === "Recall Session" && (
              <FoldedPopup
                noImage={true}
                closeButton={true}
                enabled={recallScheduledPopupEnabled}
                setEnabled={setRecallScheduledPopupEnabled}
                className="quiz-scheduled-popup"
              >
                <h1>
                  You have a Recall Session scheduled for this set right now.
                </h1>
                <p>
                  A scheduled Recall Session is available for you to take now.
                  Take it to stay on track on learning all the terms in time.
                </p>
                <CTAButton
                  text="Take me there"
                  color="purple"
                  onClick={() => {
                    let currentPath = window.location.pathname;
                    if (currentPath.endsWith("/")) {
                      currentPath = currentPath.slice(0, -1);
                    }

                    navigate(`${currentPath}/recall`);
                  }}
                ></CTAButton>

                <p
                  className="no-thanks"
                  onClick={() => {
                    setRecallScheduledPopupEnabled(false);
                  }}
                >
                  No thanks
                </p>
              </FoldedPopup>
            )}
          <section className="top">
            {setdata != undefined && setdata.terms.length > 0 && (
              <div className="left">
                <p id="study-label">Study</p>
                {setdata.psd ? (
                  <>
                    <button className="purple">
                      <img
                        src="/images/study/flashcards.svg"
                        alt="flashcards icon"
                      />
                      <p>Flashcards</p>
                    </button>

                    <button
                      className="purple recall-button"
                      onClick={function () {
                        navigate("./recall");
                        // window.location = window.location.href + "/recall";
                      }}
                    >
                      <img src="/images/study/recall.svg" alt="recall icon" />
                      <p>Recall</p>
                    </button>

                    <button
                      className={
                        "purple quiz-button " +
                        (setdata.terms.length < 2 ? "disabled-button" : "")
                      }
                      onClick={function () {
                        if (setdata.terms.length < 2) {
                          return false;
                        }
                        navigate("quiz");
                      }}
                    >
                      <img src="/images/study/quiz.svg" alt="quiz icon" />
                      <p>Quiz</p>
                    </button>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      marginTop: "15px",
                    }}
                  >
                    <WhiteButton
                      className="cta-btn"
                      text="Sign Up"
                      hoverColor={"#FF5B91"}
                      onClick={() => {
                        window.location.href = "/signup";
                      }}
                    ></WhiteButton>
                    <WhiteButton
                      text="Login"
                      hoverColor={"#FF5B91"}
                      className="cta-btn"
                      onClick={() => {
                        window.location.href = "/login";
                      }}
                    ></WhiteButton>
                  </div>
                )}

                {/*}
          <div className="coming_soon">
            <p>Coming Soon</p>
            <button>
              <img src="/images/study/quiz.svg" alt="quiz icon" />
              <p>Quiz</p>
            </button>
          </div>*/}
              </div>
            )}
            <div className="purple-background"></div>
            <div className="right">
              <div className="top_bar">
                {setdata?.average_mastery_time && (
                  <p className="avg_mastery">
                    Average Mastery Time: {setdata.avg_mastery_time} days
                  </p>
                )}

                {setdata?.psd?.test && setdata?.psd?.test?.test_date && (
                  <div className="test_announcement">
                    <p>
                      Test on {stringifyDate(setdata.psd.test.test_date, true)}
                    </p>
                  </div>
                )}

                <div className="title">
                  <div className="title-avatar-container">
                    <img className="pfp" src={setdata.creator.avatar_url} />
                    {setdata.title && (
                      <>
                        {isMobile() && (
                          <a href="/dashboard">
                            <svg
                              style={{ marginRight: "5px" }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="19.732"
                              height="13.1"
                              viewBox="0 0 19.732 13.1"
                              className="back-svg"
                            >
                              <path
                                id="keyboard_backspace_FILL0_wght400_GRAD0_opsz48"
                                d="M12.55,25.1,6,18.55,12.55,12l1.178,1.178L9.179,17.728H25.732v1.644H9.179l4.549,4.549Z"
                                transform="translate(-6 -12)"
                                fill="#ffffff"
                              />
                            </svg>
                          </a>
                        )}
                        <h1 style={isMobile ? { marginRight: "2rem" } : {}}>
                          {setdata.title}
                        </h1>
                        {setdata.editable && (
                          <img
                            className="big_pen"
                            src="/images/study/pen.svg"
                            alt="pen icon"
                            ref={pen}
                            onClick={() => {
                              navigate("./edit");
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                  <p className="n-terms">
                    {setdata &&
                      setdata.terms &&
                      Object.keys(setdata.terms).length > 0 &&
                      `${Object.keys(setdata.terms).length} term` +
                        (Object.keys(setdata.terms).length > 1 ||
                        Object.keys(setdata.terms).length == 0
                          ? "s"
                          : "")}
                  </p>
                </div>

                {setdata.creator && setdata.creator.avatar_url && (
                  <div className="user">
                    <img className="pfp" src={setdata.creator.avatar_url} />
                    <Link to={creator_url} className="username">
                      {setdata.creator.username}
                    </Link>

                    {setdata.creator.verified && (
                      <img
                        src="/images/user/check.svg"
                        title="This user is verified."
                        alt="checkmark icon"
                      />
                    )}
                    {setdata.creator.membership > 0 && (
                      <PlusIcon style={{ marginLeft: "10px" }} />
                    )}
                  </div>
                )}
              </div>
              <div className="content">
                {setdata != undefined && setdata.terms.length > 0 && (
                  <>
                    <a
                      className="arrow arrow-left"
                      onClick={onLeftArrowClicked}
                      style={{ opacity: currentCard.num == 0 ? 0.3 : 1 }}
                    >
                      &lt;
                    </a>

                    <FlipCard
                      onAnimationEnd={function (e) {
                        var animName = e.animationName;
                        var n = currentCard.num;
                        if (animName === "slideleft") {
                          setSlideLeft(0);
                          setCurrentCard({
                            front: setdata.terms[n + 1][0],
                            back: setdata.terms[n + 1][1],
                            front_img: setdata.terms[n + 1][2],
                            back_img: setdata.terms[n + 1][3],
                            front_equation: setdata.terms[n + 1][4],
                            back_equation: setdata.terms[n + 1][5],
                            num: n + 1,
                            is_mdt:
                              setdata.psd?.most_difficult_terms[n + 1] !==
                              undefined,
                          });
                          setAppear(1);
                          if (soundEnabled) {
                            cancel();
                            speak({
                              text: setdata.terms[n + 1][0],
                              voice: voices[selectedVoiceIndex],
                            });
                          }
                        } else if (animName === "slideright") {
                          setSlideRight(0);
                          setCurrentCard({
                            front: setdata.terms[n - 1][0],
                            back: setdata.terms[n - 1][1],
                            front_img: setdata.terms[n - 1][2],
                            back_img: setdata.terms[n - 1][3],
                            front_equation: setdata.terms[n - 1][4],
                            back_equation: setdata.terms[n - 1][5],
                            num: n - 1,
                            is_mdt:
                              setdata.psd?.most_difficult_terms[n - 1] !==
                              undefined,
                          });
                          setAppear(1);
                          if (soundEnabled) {
                            cancel();
                            speak({
                              text: setdata.terms[n - 1][0],
                              voice: voices[selectedVoiceIndex],
                            });
                          }
                        } else if (animName == "appear") {
                          setAppear(0);
                        }
                        setSlideDirection(null);
                      }}
                      slideleft={slideleft}
                      slideright={slideright}
                      appear={appear}
                      currentCard={currentCard}
                      nterms={setdata.terms.length}
                      soundEnabled={soundEnabled}
                      selectedVoiceIndex={selectedVoiceIndex}
                      onRightArrowClicked={onRightArrowClicked}
                      onLeftArrowClicked={onLeftArrowClicked}
                      setCardIndex={setCardIndex}
                    />

                    <a
                      className="arrow arrow-right"
                      onClick={onRightArrowClicked}
                      style={{
                        opacity:
                          currentCard.num == setdata.terms.length - 1 ? 0.3 : 1,
                      }}
                    >
                      &gt;
                    </a>
                  </>
                )}
              </div>
              <div
                className="flashcard-progress-bar"
                style={{
                  marginTop: "50px",
                }}
              >
                <ProgressBar
                  borderRadius={50}
                  completed={(currentCard.num / setdata.terms.length) * 100}
                  isLabelVisible={false}
                  bgColor={"#8358E8"}
                  height="15px"
                ></ProgressBar>
              </div>
            </div>
          </section>

          <section className="info-section">
            <div className="set-info">
              <h1 className="title">
                {setdata.title}
                {setdata.editable && (
                  <img
                    className="medium_pen"
                    src="/images/study/pen.svg"
                    alt="pen icon"
                    ref={pen}
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      navigate("./edit");
                    }}
                  />
                )}
              </h1>
              <div className="user">
                <img
                  className="pfp"
                  src={setdata.creator.avatar_url}
                  alt="User icon"
                />
                <Link to={creator_url} className="username">
                  {setdata.creator.username}
                </Link>
                {setdata.creator.verified && (
                  <img
                    src="/images/user/check.svg"
                    title="This user is verified."
                    alt="checkmark icon"
                  />
                )}
              </div>
              <div data-color-mode="light" className="description">
                <MDEditor.Markdown
                  source={setdata.description}
                ></MDEditor.Markdown>
              </div>

              <Tags tags={tags} readonly={true}></Tags>
              <div className="actions-container"></div>
            </div>
          </section>
          {setdata.psd ? (
            <>
              <section className="set-information">
                {setdata?.study_plan && setdata?.study_plan?.is_in_crunch && (
                  <CrunchTimeBar></CrunchTimeBar>
                )}

                <h2 className="your-studying">Your Studying</h2>

                <section className="test">
                  {setdata?.psd?.test?.test_date ? (
                    <>
                      <div className="date-announcement">
                        <h3>
                          Test coming up{" "}
                          {stringifyDate(
                            setdata?.psd?.test?.test_date,
                            false,
                            true
                          )}
                        </h3>
                      </div>

                      {setdata.psd &&
                        setdata.psd.test &&
                        setdata.psd.test.test_date &&
                        setdata.psd.test.started_studying_date && (
                          <>
                            <TestProgress
                              config={{
                                startDate: setdata.study_plan.created_at,
                                //setdata.psd.test.started_studying_date,
                                startLabel: "Started studying",
                                endDate: setdata.psd.test.test_date,
                                endLabel: "Test Date",
                              }}
                            />
                          </>
                        )}
                    </>
                  ) : (
                    <div className="date-announcement">
                      <h3>No Test Date</h3>
                      <p className="label">
                        Add your Test Date and Quizzy will personalize your
                        studying
                      </p>
                      {!setdata.study_plan && (
                        <WhiteButton
                          text={"Add Test Date"}
                          className="add-test-date"
                          onClick={() => {
                            setCustomSchedulePopupEnabled(true);
                          }}
                          svg={
                            <svg
                              id="pending_actions_black_24dp"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20.777"
                              height="28"
                              viewBox="0 0 20.777 28"
                            >
                              <rect
                                id="Rectangle_165"
                                data-name="Rectangle 165"
                                width="17.277"
                                height="28"
                                transform="translate(1.489)"
                                fill="none"
                              />
                              <path
                                id="Path_76"
                                data-name="Path 76"
                                d="M19.005,13.7a5.771,5.771,0,1,0,5.771,5.771A5.773,5.773,0,0,0,19.005,13.7Zm1.9,8.484L18.428,19.7V16.005h1.154v3.22l2.135,2.135ZM20.16,3.309H16.489a3.449,3.449,0,0,0-6.51,0H6.309A2.315,2.315,0,0,0,4,5.617V22.931a2.315,2.315,0,0,0,2.309,2.309h7.053a7.784,7.784,0,0,1-1.639-2.309H6.309V5.617H8.617V9.08h9.234V5.617H20.16v5.864a8.115,8.115,0,0,1,2.309.693V5.617A2.315,2.315,0,0,0,20.16,3.309ZM13.234,5.617a1.154,1.154,0,1,1,1.154-1.154A1.158,1.158,0,0,1,13.234,5.617Z"
                                transform="translate(-4 0.154)"
                                fill="#2b2b2b"
                              />
                            </svg>
                          }
                        ></WhiteButton>
                      )}
                    </div>
                  )}
                </section>
                {user.membership === 0 && <QuizzyPlusBanner></QuizzyPlusBanner>}
                {recallDates.length > 0 && (
                  <section className="recall-calendar">
                    <h3>Study Schedule</h3>
                    <p className="label">
                      Here's what your schedule looks like for this set.
                    </p>
                    <div className="progress-circles">
                      {recallDates.map((recallDate, c) => (
                        <div className="circle-container">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div
                              className={"circle"}
                              id={"circle-" + c}
                              style={
                                recallDate > new Date()
                                  ? {
                                      backgroundColor: "#7B7B7B",
                                    }
                                  : recallDate == new Date()
                                  ? {
                                      backgroundColor: "#FFFFFF",
                                      border: "4px solid #8358E8",
                                    }
                                  : {
                                      backgroundColor: "#8358E8",
                                    }
                              }
                            >
                              <svg
                                id="notifications_none_black_24dp"
                                xmlns="http://www.w3.org/2000/svg"
                                width="28.951"
                                height="31.711"
                                viewBox="0 0 28.951 31.711"
                              >
                                <path
                                  id="Path_65"
                                  data-name="Path 65"
                                  d="M0,0H28.951V31.711H0Z"
                                  fill="none"
                                />
                                <path
                                  id="Path_66"
                                  data-name="Path 66"
                                  d="M17.159,32.731a3.209,3.209,0,0,0,3.29-3.1h-6.58A3.209,3.209,0,0,0,17.159,32.731Zm9.869-9.3V15.677c0-4.759-2.681-8.744-7.4-9.8V4.825a2.472,2.472,0,0,0-4.935,0V5.88c-4.7,1.054-7.4,5.023-7.4,9.8v7.751L4,26.529v1.55H30.319v-1.55Zm-3.29,1.55H10.58v-9.3c0-3.845,2.484-6.976,6.58-6.976s6.58,3.132,6.58,6.976Z"
                                  transform="translate(-2.684 -1.677)"
                                  fill="#fff"
                                />
                              </svg>
                            </div>
                            {c != recallDates.length - 1 && (
                              <Xarrow
                                start={"circle-" + c} //can be react ref
                                end={"circle-" + (c + 1)} //or an id
                                showHead={false}
                                animateDrawing={true}
                                color={
                                  recallDate > new Date()
                                    ? "#7B7B7B"
                                    : "#8358E8"
                                }
                                path={"straight"}
                              />
                            )}

                            <p
                              style={
                                recallDate > new Date()
                                  ? {
                                      color: "#7B7B7B",
                                    }
                                  : {
                                      color: "#8358E8",
                                    }
                              }
                            >
                              {stringifyDate(recallDate, false, true)}
                            </p>
                          </div>
                        </div>
                      ))}
                      {setdata.psd.test != undefined &&
                        setdata.psd.test.test_date != undefined && (
                          <>
                            <div className="circle-container">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <div
                                  className={"circle"}
                                  id={"circle-" + parseInt(recallDates.length)}
                                  style={{
                                    backgroundColor: "#DCDCDC",
                                    border: "3px solid #7B7B7B",
                                  }}
                                >
                                  <svg
                                    id="pending_actions_black_24dp"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="29.572"
                                    height="39.854"
                                    viewBox="0 0 29.572 39.854"
                                  >
                                    <rect
                                      id="Rectangle_165"
                                      data-name="Rectangle 165"
                                      width="24.591"
                                      height="39.854"
                                      transform="translate(2.12)"
                                      fill="none"
                                    />
                                    <path
                                      id="Path_76"
                                      data-name="Path 76"
                                      d="M25.358,19.072a8.215,8.215,0,1,0,8.215,8.215A8.218,8.218,0,0,0,25.358,19.072Zm2.711,12.075-3.532-3.532V22.358h1.643v4.584l3.039,3.039ZM27,4.286H21.776a4.909,4.909,0,0,0-9.266,0H7.286A3.3,3.3,0,0,0,4,7.572V32.215A3.3,3.3,0,0,0,7.286,35.5H17.324a11.079,11.079,0,0,1-2.333-3.286H7.286V7.572h3.286V12.5H23.715V7.572H27v8.346a11.55,11.55,0,0,1,3.286.986V7.572A3.3,3.3,0,0,0,27,4.286ZM17.143,7.572a1.643,1.643,0,1,1,1.643-1.643A1.648,1.648,0,0,1,17.143,7.572Z"
                                      transform="translate(-4 0.643)"
                                      fill="#5a5a5a"
                                    />
                                  </svg>
                                </div>
                                {recallDates.length > 0 && (
                                  <Xarrow
                                    start={
                                      "circle-" +
                                      parseInt(recallDates.length - 1)
                                    } //can be react ref
                                    end={
                                      "circle-" + parseInt(recallDates.length)
                                    } //or an id
                                    showHead={false}
                                    animateDrawing={true}
                                    color={"#7B7B7B"}
                                    path={"straight"}
                                  />
                                )}

                                <p
                                  style={{
                                    color: "#7B7B7B",
                                  }}
                                >
                                  {stringifyDate(
                                    setdata.psd.test.test_date,
                                    false,
                                    true
                                  )}
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                  </section>
                )}

                <section className="recall-progress">
                  <h3>
                    Your Learning Journey
                    {setdata?.psd?.test?.test_date && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32.762"
                        height="30.65"
                        viewBox="0 0 32.762 30.65"
                        className="edit-journey"
                        onClick={() => {
                          setEditCustomSchedulePopupEnabled(true);
                        }}
                      >
                        <path
                          id="edit_FILL0_wght400_GRAD0_opsz48"
                          d="M8.682,33.491h1.967l19.8-18.524-1.967-1.84L8.682,31.651ZM36.125,13.169,30.4,7.817l1.877-1.756a2.834,2.834,0,0,1,3.754,0L38,7.9a2.409,2.409,0,0,1,0,3.512Zm-1.877,1.756L11.721,36H6V30.648L28.527,9.573Zm-4.782-.878-.983-.92,1.967,1.84Z"
                          transform="translate(-6 -5.35)"
                          fill="#848484"
                        />
                      </svg>
                    )}
                  </h3>
                  <p className="label">See how many terms you're learning</p>
                  <div className="recall_progress_chart">
                    <MultipleLineChart
                      config={recallProg}
                      height={400}
                      width={200}
                    />
                  </div>
                </section>
                <section className="my-learning">
                  <h3 id="my-learning">My Learning</h3>
                  <p className="label">
                    See how you allocate your studying for this set
                  </p>
                  <div className="doughnut-charts">
                    <div className="std-chart">
                      <h3>Study Time Distribution</h3>
                      <DoughnutChart config={studyTimeDistrib} />
                    </div>
                    <div className="mastery-chart">
                      <h3>Mastery Progress</h3>
                      <DoughnutChart config={masteryProg} />
                    </div>
                  </div>
                </section>
                <section className="time-spent-on-learning">
                  <h3>Time Spent on Learning Today</h3>
                  <p className="label">
                    See how you've spent your time learning terms for this set
                  </p>
                  <div className="tsol-chart">
                    <LineChart
                      width={800}
                      height={320}
                      data={timeSpentOnLearning}
                    />
                  </div>
                </section>
                {user.membership > 2 ? (
                  <>
                    <MostDifficultTerms></MostDifficultTerms>
                  </>
                ) : (
                  <SampleData>
                    <MostDifficultTerms></MostDifficultTerms>
                  </SampleData>
                )}

                <section className="compare-with-friends">
                  <h3>Compare with your friends</h3>
                  <p className="label">
                    {Object.keys(friendsRecallProgress).length > 0 &&
                    leaderboardKeys.length > 0
                      ? "Compare with your friends to see how well you're doing."
                      : "Invite your friends to study this set, and see their progress here."}
                  </p>
                  {Object.keys(friendsRecallProgress).length > 0 &&
                  leaderboardKeys.length > 0 ? (
                    <>
                      <section className="recall-progress">
                        <div className="select-range-cover">
                          <p className="label">Choose Range</p>
                          <select
                            name="range"
                            id="range"
                            onChange={(e) => {
                              updateFriendsRecallProgressChartRange(
                                e.target.value
                              );
                            }}
                          >
                            <option value="this_week">This Week</option>
                            <option value="this_month">This Month</option>
                            <option value="this_year">This Year</option>
                            <option value="lifetime">Lifetime</option>
                          </select>
                        </div>

                        <h3>Recall Progress</h3>
                        {Object.keys(friendsRecallProgress).length == 0 ? (
                          <p className="label">
                            Invite some friends to study this set, and view your
                            progress here.
                          </p>
                        ) : (
                          <>
                            <p className="label">
                              Compare your progress to your friends.
                            </p>
                            <div className="recall_progress_chart recall_progress_friends_chart">
                              <MultipleLineChart config={friendsRecallProg} />
                            </div>
                          </>
                        )}
                      </section>
                      <section className="leaderboard">
                        <h3>Leaderboard</h3>
                        <p className="label">
                          {leaderboardKeys.length > 0
                            ? "See which friends know the most terms in this set."
                            : "Invite some friends to study this set and join the leaderboard."}
                        </p>
                        <div className="leaderboard-container">
                          {leaderboardKeys.map((username, idx) => (
                            <div className="leaderboard-user">
                              <p className="position label">
                                {"#" + parseInt(idx + 1)}
                              </p>
                              <div className="avatar-wrap">
                                <img
                                  className="avatar"
                                  alt="avatar"
                                  src={friendsRecallProgress[username][2]}
                                ></img>
                                <div
                                  className={
                                    "status " +
                                    friendsRecallProgress[username][3]
                                  }
                                ></div>
                              </div>
                              <div className="username-progress">
                                <p className="label username-label">
                                  {"@" + username}
                                </p>
                                <div className="progress-bar">
                                  <ProgressBar
                                    borderRadius={50}
                                    completed={leaderboard[username]}
                                    isLabelVisible={false}
                                    className="prog-bar"
                                    bgColor={
                                      "#8358E8" /*["#FFD54D", "#575757", "#957750"][idx] ?? "#8358E8"*/
                                    }
                                    height="15px"
                                  ></ProgressBar>
                                  {
                                    <p className="label">
                                      {Math.ceil(leaderboard[username]) + "%"}
                                    </p>
                                  }
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="leaderboard"></div>
                      </section>
                      {user?.plans?.analytics != undefined ? (
                        <FriendComparison></FriendComparison>
                      ) : (
                        <SampleData>
                          <FriendComparison></FriendComparison>
                        </SampleData>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </section>
              </section>
            </>
          ) : (
            <section className="set-information">
              <h2 className="your-studying guest-h2">
                You are currently not signed in.
              </h2>
              <p className="guest">
                Since you don't have an account with us, you're missing out on a
                lot of awesome features that we provide. To view information
                about your studying, take unlimited practice quizzes and more,
                please sign up to Quizzy, or login to your Quizzy account.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "15px",
                }}
              >
                <WhiteButton
                  className="cta-btn"
                  text="Sign Up"
                  hoverColor={"#FF5B91"}
                  onClick={() => {
                    window.location.href = "/signup";
                  }}
                ></WhiteButton>
                <WhiteButton
                  text="Login"
                  hoverColor={"#FF5B91"}
                  className="cta-btn"
                  onClick={() => {
                    window.location.href = "/login";
                  }}
                ></WhiteButton>
              </div>
            </section>
          )}
        </main>
      </div>
    </>
  );
}

export default Study;
